<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" :label-width="100">
      <FormItem label="围栏名称" prop="companyId">
        <span>{{form.gfName}}</span>
      </FormItem>
      <FormItem label="车辆编号" prop="applyCount">
        <span>{{form.carNo}}</span>
      </FormItem>
      <FormItem label="围栏类型" prop="connectName">
        <span>{{$utils.value2label(gfTypeData,form.gfType)}}</span>
      </FormItem>
      <FormItem label="报警类型" prop="connectPhone">
        <span>{{$utils.value2label(alarmTypeData,form.alarmType)}}</span>
      </FormItem>
      <FormItem label="所属企业" prop="area">
        <span>{{form.companyName}}</span>
      </FormItem>
      <FormItem label="当前快递员" prop="address">
        <span>{{form.driverName}}</span>
      </FormItem>
      <FormItem label="快递员电话" prop="imgPath">
        <span>{{form.driverPhone}}</span>
      </FormItem>
    </Form>
    <sl-amap style="height: 500px;">
      <sl-amap-shape ref="shape"></sl-amap-shape>
    </sl-amap>
  </sl-side-panel>
</template>
<script>
import dics from './dics'
import { geometryValidator } from '@/util/validator'
const toGeom = (data) => {
  let geometry = {
    type: data.category
  }

  if (data.category == 1) {
    geometry.coordinates = [{ lat: data.centerLat, lng: data.centerLng }]
    geometry.radius = data.radius
  } else if (data.category == 2) {
    geometry.coordinates = JSON.parse(data.pointList)
  }

  console.log(geometry)
  return geometry
}

const fromGeom = (geometry) => {
  let params = {}
  if (geometry) {
    params.category = geometry.type
    if (geometry.type == 2) {
      params.points = geometry.coordinates
    } else if (geometry.type == 1) {
      params.centerLat = geometry.coordinates[0].lat
      params.centerLng = geometry.coordinates[0].lng
      params.radius = geometry.radius
    }
  }
  console.log('>>', params)
  return params
}

export default {
  components: {},
  data() {
    return {
      def: {},
      form: {
        alarmAddrDetail: null,
        alarmLat: null,
        alarmLng: null,
        alarmTime: null,
        alarmType: null,
        carNo: null,
        companyName: null,
        driverName: null,
        driverPhone: null,
        gfId: null,
        gfName: null,
        gfPoints: null,
        gfType: null,
        id: null,
      },
      id: null,
      loading: false,
      isCreate: true,
      companies: [],
      modalVisible: false,
      ...dics,
      fenceObj: {},
    }
  },

  computed: {
    itemTitle() {
      return '查看预警地图'
    }
  },
  created() {
    this.def = { ...this.form }
  },

  methods: {
    show() {
      this.modalVisible = true
    },

    hide() {
      this.modalVisible = false
    },

    init(id) {
      this.id = id
      this.show()
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.fenceAlarmMsgQueryId(this.id).then(resp => {
        this.form = resp.data
        this.fence(resp.data.gfId)
        this.initMarker()
      })
    },
    // fence
    fence(id) {
      this.$request.fence(id).then(resp => {
        this.fenceObj = resp.data
        this.initShape()
      })
    },

    reset() {},

    save() {},

    handleSubmit(name) {},

    handleClose() {},

    initMarker() {
      let data = [this.form.alarmLng, this.form.alarmLat]
      setTimeout(() => {
        this.$refs.shape.initMarker(data)
      }, 50)
    },
    initShape() {
      this.$refs.shape.clearShape()
      if (!this.fenceObj || !this.fenceObj.points) {
        return
      }
      // category
      // 围栏种类，1：圆形，2：多边形（包括矩形）
      let shapeType = ''
      let data = null
      let len = this.fenceObj.points.length

      if (len === 1) {
        shapeType = 'Circle'
        let lnglatArr = [this.fenceObj.points[0].lng, this.fenceObj.points[0].lat]
        data = { data: lnglatArr, radius: this.fenceObj.radius }
      } else if (len === 2) {
        shapeType = 'Rectangle'
        let lnglatArr = []
        this.fenceObj.points.forEach(item => {
          lnglatArr.push([item.lng, item.lat])
        })
        data = lnglatArr
      } else if (len > 3) {
        shapeType = 'Polygon'
        let lnglatArr = []
        this.fenceObj.points.forEach(item => {
          lnglatArr.push([item.lng, item.lat])
        })
        data = lnglatArr
      }
      if (!shapeType) {
        return
      }
      this.$refs.shape.initShapeType(shapeType, data)
    },

  }
}

</script>
